import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const platforms = [
  { key: "spotify", label: "Spotify", icon: "fa-brands fa-spotify" },
  { key: "apple", label: "Apple Music", icon: "fa-brands fa-apple" },
  { key: "youtube", label: "YouTube", icon: "fa-brands fa-youtube" },
];

export default function StreamingLinks({ links = {} }) {
  return (
    <section
      data-testid="streaming-section"
      className="relative w-full px-5 md:px-10 py-20 md:py-28 border-t border-zinc-900"
    >
      <div className="max-w-4xl mx-auto w-full">
        <div className="mb-10 md:mb-14">
          <p className="font-mono text-[11px] uppercase tracking-[0.35em] text-zinc-500 mb-3">
            Stream Everywhere — Free
          </p>
          <h2 className="font-display font-black text-3xl md:text-5xl tracking-tighter text-white">
            Play the tape anywhere
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4">
          {platforms.map((p, i) => {
            const href = links[p.key];
            const disabled = !href;
            return (
              <motion.a
                key={p.key}
                data-testid={`stream-${p.key}`}
                href={href || undefined}
                target={href ? "_blank" : undefined}
                rel="noopener noreferrer"
                onClick={(e) => disabled && e.preventDefault()}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className={`group relative flex flex-col justify-between h-40 md:h-48 border border-zinc-800 p-5 transition-all duration-300 ${
                  disabled
                    ? "opacity-70 cursor-default"
                    : "hover:border-white hover:bg-white hover:text-black cursor-pointer"
                }`}
              >
                <div className="flex items-center justify-between">
                  <i
                    className={`${p.icon} text-2xl md:text-3xl ${
                      disabled ? "text-zinc-500" : "text-white group-hover:text-black"
                    } transition-colors`}
                  />
                  <ArrowUpRight
                    size={18}
                    className={`transition-transform duration-300 ${
                      disabled
                        ? "text-zinc-700"
                        : "text-zinc-500 group-hover:text-black group-hover:translate-x-1 group-hover:-translate-y-1"
                    }`}
                  />
                </div>
                <div>
                  <p
                    className={`font-display font-bold text-xl md:text-2xl tracking-tight ${
                      disabled ? "text-zinc-400" : "group-hover:text-black"
                    }`}
                  >
                    {p.label}
                  </p>
                  <p
                    className={`font-mono text-[10px] uppercase tracking-widest mt-1 ${
                      disabled ? "text-zinc-600" : "text-zinc-500 group-hover:text-black/60"
                    }`}
                  >
                    {disabled ? "Link coming soon" : "Listen free"}
                  </p>
                </div>
              </motion.a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
